import { jsx as _jsx } from "react/jsx-runtime";
import { PlateElement, PlateLeaf } from '@udecode/plate/react';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { CodeBlockWrapper } from './styled';
const StyledPre = styled.pre`
  overflow-x: clip;
  overflow-y: auto;
  max-height: 132px;
  border-radius: 0.375rem;
  line-height: normal;
  margin: 1rem 0px;
  &&& {
    padding: 1.5rem 1rem;
    border: 0px;
  }
`;
export const CodeBlockElement = /*#__PURE__*/ forwardRef(({ children, className, ...props }, ref)=>{
    return /*#__PURE__*/ _jsx(CodeBlockWrapper, {
        ...props,
        className: className,
        children: /*#__PURE__*/ _jsx(StyledPre, {
            children: /*#__PURE__*/ _jsx("code", {
                children: children
            })
        })
    });
});
export const CodeLineElement = /*#__PURE__*/ forwardRef((props, ref)=>{
    return /*#__PURE__*/ _jsx(PlateElement, {
        ref: ref,
        ...props
    });
});
export const CodeSyntaxLeaf = /*#__PURE__*/ forwardRef(({ children, ...props }, ref)=>{
    const { leaf } = props;
    const tokenClassName = leaf.className;
    return /*#__PURE__*/ _jsx(PlateLeaf, {
        ref: ref,
        ...props,
        children: /*#__PURE__*/ _jsx("span", {
            className: tokenClassName,
            children: children
        })
    });
});
